import { render, staticRenderFns } from "./index.vue?vue&type=template&id=fdb20c68&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdb20c68",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fdb20c68')) {
      api.createRecord('fdb20c68', component.options)
    } else {
      api.reload('fdb20c68', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=fdb20c68&scoped=true", function () {
      api.rerender('fdb20c68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/runActivityManage/pushManage/index.vue"
export default component.exports